import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFetch } from '../../hooks/useFetch';
import { getImageUrl } from '../../helpers/img-resolve';

const tabs = [
  { id: 'descriptions', label: 'Descriere' },
  { id: 'reviews', label: 'Recenzii' },
  { id: 'contacts', label: 'Contacte' }
];

export const useServiceByIdViewModel = () => {

  const [showMore, setShowMore] = useState(false);
  const [showMoreReviews, setShowMoreReviews] = useState(false);

  const { serviceId } = useParams();

  const { data: serviceApi, isLoading } = useFetch(`repair-service/${serviceId}`)

  const service = serviceApi?.payload ?? null

  const serviceName = service?.name?.split('-')[0].trim() ?? '';

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const reviews = service?.rating?.reviews ?? []

  const activities = (service?.activities ?? []).map(activity => ({
    name: activity.name,
    img: activity.icon ? getImageUrl('icons', activity.icon) : undefined
  }));

  const facilities = (service?.facilities ?? []).map(facility => ({
    name: facility.name,
    img: facility.icon ? getImageUrl('icons', facility.icon) :undefined,
  }));

  const gallery = (service?.gallery ?? []).map(image => ({
    src: getImageUrl('img', image.url),
    alt: image.description
  }));

  const toggleMoreReviews = () => {
    setShowMoreReviews((prev) => !prev);
  }

  const scrollToElement = (ref) => {
    const headerHeight = 68;
    const element = ref.current;
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 16; // added extra padding

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const contactRef = useRef(null);
  const descriptionRef = useRef(null);
  const reviewsRef = useRef(null);


  const onTabChange = (tabId) => {
    switch (tabId) {
      case 'descriptions':
        scrollToElement(descriptionRef);
        break;
      case 'contacts':
        scrollToElement(contactRef)
        break;
      case 'reviews':
        scrollToElement(reviewsRef);
        break;
      default:
        break;
    }
    setActiveTab(tabId);
  }


  // useEffect(() => {
  //   // Create an intersection observer with lower threshold
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       if (entries[0].isIntersecting) {
  //         setActiveTab('descriptions');
  //       }
  //     },
  //     {
  //       threshold: 0.1,
  //       rootMargin: '0px'
  //     }
  //   );
  //
  //
  //   if (tabsRef.current) {
  //     observer.observe(tabsRef.current);
  //   }
  //
  //   return () => {
  //     if (tabsRef.current) {
  //       observer.unobserve(tabsRef.current);
  //     }
  //   };
  // }, []);


  const handleShowMore = () => {
    setShowMore((prev)=>!prev);
  }

  // Add a ref for the tabs container
  const tabsRef = useRef(null);


  const hasReview = service?.rating ?? null
  return {
    refs: {
      contactRef,
      descriptionRef,
      reviewsRef,
      tabsRef
    },
    showMore,
    setShowMore,
    serviceName,
    showMoreReviews,
    setShowMoreReviews,
    activeTab,
    hasReview,
    setActiveTab,
    isLoading,
    service,
    activities,
    reviews,
    facilities,
    gallery,
    onTabChange,
    toggleMoreReviews,
    tabs,
    handleShowMore,
  }

}